import { submitChatLead } from '../services/chatLeadService';
import { useTranslation } from 'react-i18next';
// src/components/ContactUs.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './ContactUs.css';
import HoneypotField, { isHoneypotSubmission } from './HoneypotField';

const ContactUs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    postalCode: '',
    serviceReq: 'buying'
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isHoneypotSubmission(e.currentTarget)) {
      setSuccess(true);
      setFormData({ name: '', email: '', phoneNumber: '', postalCode: '', serviceReq: 'buying' });
      setTimeout(() => setSuccess(false), 5000);
      return;
    }

    setSubmitting(true);
    try {
      const params = new URLSearchParams({
        postalCode: formData.postalCode,
        name: formData.name,
        phoneNumber: formData.phoneNumber,
        serviceReq: formData.serviceReq,
        email: formData.email,
        siteId: SITE_CONFIG.SITE_ID
      });

      const response = await submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?${params}`).searchParams, { rememberContact: true });

      if (response.ok) {
        setSuccess(true);
        setFormData({ name: '', email: '', phoneNumber: '', postalCode: '', serviceReq: 'buying' });
        setTimeout(() => setSuccess(false), 5000);
      } else {
        alert('Failed to submit. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-us-page">
      <button className="back-button" onClick={() => navigate('/')}>
        {t('nav.backToHome')}
      </button>

      <div className="contact-us-container">
        <div className="contact-us-header">
          <h1>{t('contact.title')}</h1>
          <p>Ready to find your dream home or sell your property? Get in touch with {SITE_CONFIG.AGENT.NAME} today!</p>
        </div>

        <div className="contact-us-content">
          <div className="contact-info-section">
            <h2>{t('contact.getInTouch')}</h2>
            <div className="contact-detail">
              <strong>{t('form.email')}</strong>
              <p>{SITE_CONFIG.AGENT.EMAIL}</p>
            </div>
            <div className="contact-detail">
              <strong>{t('agent.phone')}</strong>
              <p>{SITE_CONFIG.AGENT.PHONE}</p>
            </div>
            <div className="contact-detail">
              <strong>{t('agent.brokerage')}</strong>
              <p>{SITE_CONFIG.AGENT.BROKERAGE}</p>
            </div>
            <div className="contact-detail">
              <strong>{t('agent.license')}</strong>
              <p>{SITE_CONFIG.AGENT.LICENSE}</p>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>{t('contact.sendMessage')}</h2>
            {success && (
              <div className="success-message">
                ✓ {t('landing.thankYou')}
              </div>
            )}
            <form onSubmit={handleSubmit}>
          <HoneypotField />
              <input
                type="text"
                placeholder={t('form.fullName') + ' *'}
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
              <input
                type="email"
                placeholder={t('form.email') + ' *'}
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
              />
              <input
                type="tel"
                placeholder={t('form.phoneNumber') + ' *'}
                value={formData.phoneNumber}
                onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
                required
              />
              <input
                type="text"
                placeholder={t('form.zipCode') + ' *'}
                value={formData.postalCode}
                onChange={(e) => setFormData({...formData, postalCode: e.target.value})}
                required
              />
              <select
                value={formData.serviceReq}
                onChange={(e) => setFormData({...formData, serviceReq: e.target.value})}
                required
              >
                <option value="buying">{t('form.buying')}</option>
                <option value="selling">{t('form.selling')}</option>
                <option value="both">{t('form.both')}</option>
              </select>
              <button type="submit" disabled={submitting}>
                {submitting ? t('form.submitting') : t('form.submit')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
